// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"daaacf1b","732":"cf6c6589","977":"1f202364"}[chunkId] + ".chunk.js";
};